import { render } from "./binding.vue?vue&type=template&id=cee5761e"
import script from "./binding.vue?vue&type=script&lang=ts"
export * from "./binding.vue?vue&type=script&lang=ts"
script.render = render

export default script